export default __webpack_public_path__ + "static/media/37.b6e35fee.jpg";